import { motion } from 'framer-motion'
import { TESTIMONIALS } from '../data/travel'

const ease = [0.16, 1, 0.3, 1]

export default function Testimonials() {
  return (
    <section id="opiniones" className="scroll-mt-16 px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl">
        <h2 className="max-w-xl font-display text-3xl font-extrabold tracking-tight text-navy-950 md:text-5xl">
          Viajeros que ya volvieron.
        </h2>
        <div className="-mx-4 mt-10 flex snap-x snap-mandatory gap-5 overflow-x-auto px-4 pb-4 [scrollbar-width:none] md:mx-0 md:grid md:grid-cols-3 md:overflow-visible md:px-0">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.55, ease, delay: i * 0.08 }}
              className="w-[82%] shrink-0 snap-start rounded-2xl bg-white p-7 md:w-auto"
            >
              <blockquote className="text-lg leading-relaxed text-navy-950 md:text-xl">"{t.quote}"</blockquote>
              <figcaption className="mt-6 text-sm">
                <span className="font-semibold text-navy-950">{t.name}</span>
                <span className="block text-navy-700/60">{t.trip}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  )
}
